import React from 'react'

export default function Refund() {
  return (
    <div className="bg-black text-white min-h-screen py-12 px-4">
      <div className="max-w-7xl mx-auto space-y-12">
        <header className="space-y-4">
          <h1 className="text-4xl font-extrabold">Cancellation and Refund Policy</h1>
          <p className="text-lg text-gray-300">
            Bristu Learning App understands that circumstances may change. This Cancellation and Refund Policy outlines the terms for canceling your enrollment in our courses and requesting refunds.
          </p>
        </header>

        <section className="space-y-10">
          {/* Course Cancellation by User */}
          <div className="bg-gray-900 rounded-2xl p-6 shadow-lg space-y-3">
            <h2 className="text-2xl font-bold text-white">Course Cancellation by User</h2>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li><strong className="text-white">Cancellation Window:</strong> Users can cancel their enrollment within 7 days of signing up.</li>
              <li><strong className="text-white">Cancellation Process:</strong> Cancellations can be made through the website or by contacting our customer support.</li>
              <li><strong className="text-white">Eligibility:</strong> Only courses that have not been accessed or started are eligible for cancellation.</li>
            </ul>
          </div>

          {/* Refund Policy */}
          <div className="bg-gray-900 rounded-2xl p-6 shadow-lg space-y-3">
            <h2 className="text-2xl font-bold text-white">Refund Policy</h2>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li><strong className="text-white">Refund Amount:</strong> Full refunds are available if cancellation is made within the eligible window.</li>
              <li><strong className="text-white">Refund Method:</strong> Refunds will be issued to the original payment method used during enrollment.</li>
              <li><strong className="text-white">Processing Time:</strong> Refunds are processed within 7–10 business days after approval.</li>
              <li><strong className="text-white">Non-Refundable Items:</strong> Downloaded resources, completed modules, and administrative fees are non-refundable.</li>
            </ul>
          </div>

          {/* Course Cancellation by Bristu */}
          <div className="bg-gray-900 rounded-2xl p-6 shadow-lg space-y-3">
            <h2 className="text-2xl font-bold text-white">Course Cancellation by Bristu Learning App</h2>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li><strong className="text-white">Reasons for Cancellation:</strong> Bristu Learning App may cancel a course due to low enrollment, unforeseen technical issues, or other operational needs.</li>
              <li><strong className="text-white">Refund for Cancellation:</strong> If Bristu Learning App cancels a course, users will receive a full refund.</li>
            </ul>
          </div>

          {/* Special Circumstances */}
          <div className="bg-gray-900 rounded-2xl p-6 shadow-lg space-y-3">
            <h2 className="text-2xl font-bold text-white">Special Circumstances</h2>
            <p className="text-gray-300">
              In exceptional cases such as medical emergencies or other critical situations, refund requests will be evaluated individually. Please contact our support team with appropriate documentation.
            </p>
          </div>
        </section>
      </div>
    </div>
  )
}
